import { defineMessages } from 'react-intl';

export default defineMessages({
  homePage: {
    id: 'homePage',
    defaultMessage: 'Home'
  },
  accountPage: {
    id: 'accountPage',
    defaultMessage: 'Account'
  },
  ordersPage: {
    id: 'ordersPage',
    defaultMessage: 'Orders'
  },
  mcpPage: {
    id: 'mcpPage',
    defaultMessage: 'Custom products'
  }
});
